import axios from 'axios'
import Cookies from 'js-cookie'

export const http = axios.create({
    // baseURL: 'http://localhost:8000/api/',
    baseURL: 'https://lineapps.com.br/api/',
    // baseURL: 'https://pgpaf.com.br/api/',
    // baseURL: 'https://pgpaf.com.br:8443/api/',
    headers: {
        "Content-type": "application/json"
    },

    withCredentials: true
})

export const httpPublic = axios.create({
    headers: {
        "Content-type": "application/json"
    },

    withCredentials: false
})

http.interceptors.request.use(config => {
    const csrfToken = Cookies.get('csrftoken')
    if (csrfToken) {
        config.headers['X-CSRFTOKEN'] = csrfToken
    }
    return config
})